import { printf, toText } from "./fable_modules/fable-library-js.4.25.0/String.js";
import { RemotingModule_createApi, RemotingModule_withRouteBuilder, RemotingModule_withAuthorizationHeader } from "./fable_modules/Fable.Remoting.Client.7.35.0/Remoting.fs.js";
import { Remoting_buildProxy_64DC51C } from "./fable_modules/Fable.Remoting.Client.7.35.0/Remoting.fs.js";
import { Security_SecuredUserManagementApi$2_$reflection, Security_UserViewModel$2_$reflection, Security_SecuredAuthApi$1_$reflection, Security_UserInfo$2_$reflection, Security_PublicAuthApi_$reflection, Route_builder } from "./fable_modules/Webbler.Models.1.3.1/Api.fs.js";
import { UserData_$reflection, UserRole_$reflection } from "./ThreeDocs.Models/Security.js";
import { PublicPatientPackagesApi_$reflection, SecuredApi_$reflection } from "./ThreeDocs.Models/Api/Api.js";
import { SecuredAwsApi_$reflection } from "./ThreeDocs.Models/Api/AwsApi.js";

function withToken(t) {
    const token = toText(printf("Bearer %s"))(t);
    return (options) => RemotingModule_withAuthorizationHeader(token, options);
}

export const publicAuthApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(Route_builder, RemotingModule_createApi()), Security_PublicAuthApi_$reflection());

export function securedAuthApi(token) {
    return Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(Route_builder, withToken(token)(RemotingModule_createApi())), Security_SecuredAuthApi$1_$reflection(Security_UserInfo$2_$reflection(UserRole_$reflection(), UserData_$reflection())));
}

export function securedApi(token) {
    return Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(Route_builder, withToken(token)(RemotingModule_createApi())), SecuredApi_$reflection());
}

export function securedUserManagementApi(token) {
    return Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(Route_builder, withToken(token)(RemotingModule_createApi())), Security_SecuredUserManagementApi$2_$reflection(Security_UserInfo$2_$reflection(UserRole_$reflection(), UserData_$reflection()), Security_UserViewModel$2_$reflection(UserRole_$reflection(), UserData_$reflection())));
}

export const publicPatientPackagesApi = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(Route_builder, RemotingModule_createApi()), PublicPatientPackagesApi_$reflection());

export function securedAwsApi(token) {
    return Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(Route_builder, RemotingModule_withAuthorizationHeader(`Bearer ${token}`, RemotingModule_createApi())), SecuredAwsApi_$reflection());
}

